// ═══════════════════════════════════════════════════════════════
// API: COMPANIES
// Servicios para gestión de compañías
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const companiesAPI = {
  // Obtener compañías del usuario actual
  getMyCompanies: async () => {
    const response = await api.get('/companies/my-companies');
    return response.data;
  },

  // Obtener todas las compañías (solo super admin)
  getAll: async (params = {}) => {
    const response = await api.get('/companies', { params });
    return response.data;
  },

  // Obtener compañía por ID
  getById: async (id) => {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  },

  // Crear nueva compañía (solo super admin)
  create: async (companyData) => {
    const formData = new FormData();
    
    Object.keys(companyData).forEach(key => {
      if (companyData[key] !== null && companyData[key] !== undefined) {
        if (key === 'logo' && companyData[key] instanceof File) {
          formData.append('logo', companyData[key]);
        } else if (key === 'configuracion' && typeof companyData[key] === 'object') {
          formData.append('configuracion', JSON.stringify(companyData[key]));
        } else {
          formData.append(key, companyData[key]);
        }
      }
    });
    
    const response = await api.post('/companies', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Actualizar compañía
  update: async (id, companyData) => {
    const formData = new FormData();
    
    Object.keys(companyData).forEach(key => {
      if (companyData[key] !== null && companyData[key] !== undefined) {
        if (key === 'logo' && companyData[key] instanceof File) {
          formData.append('logo', companyData[key]);
        } else if (key === 'configuracion' && typeof companyData[key] === 'object') {
          formData.append('configuracion', JSON.stringify(companyData[key]));
        } else {
          formData.append(key, companyData[key]);
        }
      }
    });
    
    const response = await api.put(`/companies/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Desactivar compañía (solo super admin)
  delete: async (id) => {
    const response = await api.delete(`/companies/${id}`);
    return response.data;
  },

  // Obtener usuarios de una compañía
  getUsers: async (companyId) => {
    const response = await api.get(`/companies/${companyId}/users`);
    return response.data;
  },

  // Asignar usuario a compañía
  assignUser: async (companyId, userId, data) => {
    const response = await api.post(`/companies/${companyId}/users/${userId}`, data);
    return response.data;
  },

  // Remover usuario de compañía
  removeUser: async (companyId, userId) => {
    const response = await api.delete(`/companies/${companyId}/users/${userId}`);
    return response.data;
  }
};
